import * as React from 'react';
import * as styles from './styles.css';
import { ArticleHeading2, ArticleParagraph2, LinkButton, UIText2, Button } from '@cian/ui-kit';
import cn from 'classnames';
import { formatPhone } from '@cian/frontend-e2e-deal-component';
import { useShowBanner } from './utils/useShowBanner';
import { getConfig } from '@cian/config/browser';
import { useIsDesktop } from '../../utils/useIsDesktop';

interface IDesktopButtonContentProps {
  phone: string;
  isShowNumber: boolean;
  onClick: () => void;
}

const DesktopButtonContent: React.FC<IDesktopButtonContentProps> = ({ phone, isShowNumber, onClick }) => {
  return isShowNumber ? (
    <div className={styles['number']}>{formatPhone({ phone, template: '$1 $2 $3-$4-$5' })}</div>
  ) : (
    <Button fullWidth size="XS" onClick={onClick}>
      {formatPhone({ phone, template: '$1 $2 $3-$4-...' })}
    </Button>
  );
};

export const CallUsBanner: React.FC = () => {
  const config = getConfig();
  const isCallUsBannerEnabled = config.get<boolean>('agents-directory-frontend.CallUsBanner.Enabled');
  const phone = config.get<string>('agents-directory-frontend.CallUsBannerPhone') || '';
  const isDesktop = useIsDesktop();
  const { showPhone, isShowPhone, trackCallLink } = useShowBanner();

  if (!isCallUsBannerEnabled) {
    return null;
  }

  return (
    <div>
      <div className={cn(!isDesktop && styles['top-line-mobile'])} />
      <div className={cn(styles['wrapper'], { [styles['wrapper-mobile']]: !isDesktop })}>
        <div className={cn(!isDesktop && styles['text-content-mobile'])}>
          <div className={cn(styles['title'], { [styles['title-mobile']]: !isDesktop })}>
            <ArticleHeading2>Позвоните нам</ArticleHeading2>
          </div>
          <ArticleParagraph2>Мы бесплатно подберём риелтора по вашим запросам</ArticleParagraph2>
        </div>
        <div className={cn(styles['button-wrapper'], { [styles['button-wrapper-mobile']]: !isDesktop })}>
          <div className={styles['link']}>
            {isDesktop ? (
              <DesktopButtonContent phone={phone} isShowNumber={isShowPhone} onClick={showPhone} />
            ) : (
              <LinkButton fullWidth onClick={trackCallLink} size="M" href={`tel:${phone}`}>
                Позвонить
              </LinkButton>
            )}
          </div>
          <UIText2 color="black_60">Для звонков по России</UIText2>
        </div>
      </div>
    </div>
  );
};

CallUsBanner.displayName = 'CallUsBanner';
